<template>
    <Dialog v-model:visible="isVisible" :header="$t('settings.categories.addCategory')" modal
        :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <CategoryForm @submitted="handleSubmitted" @cancel="handleCancel" />
    </Dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'primevue/dialog';
import CategoryForm from './CategoryForm.vue';

const { t } = useI18n();

const props = defineProps<{
    visible: boolean;
}>();

const emit = defineEmits<{
    (e: 'update:visible', value: boolean): void;
    (e: 'submitted'): void;
    (e: 'cancel'): void;
}>();

// Computed properties
const isVisible = computed({
    get: () => props.visible,
    set: (value: boolean) => emit('update:visible', value)
});

// Methods
const handleSubmitted = () => {
    emit('submitted');
};

const handleCancel = () => {
    emit('cancel');
};
</script>